import { render, staticRenderFns } from "./postName.vue?vue&type=template&id=b37a79da"
import script from "./postName.vue?vue&type=script&lang=js"
export * from "./postName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports